const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');

module.exports = withRenderedMain(BaseView.extend({
    events: {
        'tap .hotline_service': 'onHotlineServiceClick',
    },

    onHotlineServiceClick(e) {
        const element = $(e.currentTarget);
        const action = 'prime_support';
        const tag = element.data('trackingTag');
        Odigeo.trigger(`${this.id}:track`, {action, tag});
    },
}));
